import { ReactNode } from 'react'

export default function Paragraph({ children }: { children: ReactNode }): React.ReactElement {
  return <p className="max-w-2xl leading-7 text-black-light">{children}</p>
}
